import { render, staticRenderFns } from "./VvDesktopTile.vue?vue&type=template&id=56b5668d&scoped=true&"
import script from "./VvDesktopTile.vue?vue&type=script&lang=js&"
export * from "./VvDesktopTile.vue?vue&type=script&lang=js&"
import style0 from "./VvDesktopTile.vue?vue&type=style&index=0&id=56b5668d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5668d",
  null
  
)

export default component.exports